import React from "react";
import { useNavigate } from "react-router-dom";
import Ultratech from "../../assets/PartnerLogos/Ultratech.png";
import Kajaria from "../../assets/PartnerLogos/Kajaria.png";
import Jindal from "../../assets/PartnerLogos/Jindal.png";
import Johnson from "../../assets/PartnerLogos/Johnson.png";
import Dalmia from "../../assets/PartnerLogos/Dalmia.png";
import Hindware from "../../assets/PartnerLogos/Hindware.png";
import Nuvoco from "../../assets/PartnerLogos/Nuvoco.png";
import Tata from "../../assets/PartnerLogos/TataTiscon.png";
import Jk from "../../assets/PartnerLogos/jklakshmi.png";

const logos = [
  { src: Ultratech, alt: "Ultratech Cement", brand: "ultratech" },
  { src: Kajaria, alt: "Kajaria Ceramics", brand: "kajaria" },
  { src: Jindal, alt: "Jindal Steel & Power", brand: "jindal" },
  { src: Johnson, alt: "Johnson Tiles", brand: "johnson" },
  { src: Dalmia, alt: "Dalmia Cement", brand: "dalmia" },
  { src: Hindware, alt: "Hindware Sanitaryware", brand: "hindware" },
  { src: Nuvoco, alt: "Nuvoco Cement", brand: "nuvoco" },
  { src: Tata, alt: "Tata Tiscon Steel", brand: "tata" },
  { src: Jk, alt: "JK Lakshmi Cement", brand: "jk" },
];

const Partners = () => {
  const navigate = useNavigate();

  const handlePartnerClick = (brand) => {
    navigate(`/products?brand=${brand}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="bg-white py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden">
          {/* Gradient fade effects */}
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10"></div>
          
          <div 
            className="flex items-center gap-8 animate-slide-right hover:animation-paused"
            style={{
              animationDuration: "40s",
              animationIterationCount: "infinite",
              animationTimingFunction: "linear"
            }}
            aria-label="Partner logos carousel"
          >
            {[...logos, ...logos].map((logo, index) => (
              <button
                key={`${logo.brand}-${index}`}
                onClick={() => handlePartnerClick(logo.brand)}
                className="flex-shrink-0 focus:outline-none group"
                aria-label={`View ${logo.alt} products`}
              >
                <div className="relative transition-all duration-300 group-hover:scale-90 group-focus:scale-50">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-24 w-24 sm:h-48 sm:w-48 object-contain opacity-90 hover:opacity-100 transition-opacity"
                    loading="lazy"
                    width={96}
                    height={96}
                  />
                  <div className="absolute inset-0 rounded-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes slide-right {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-slide-right {
          animation: slide-right 40s linear infinite;
        }
        .hover\:animation-paused:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Partners;











// import React from "react";
// import { useNavigate } from "react-router-dom";
// import Ultratech from "../../assets/PartnerLogos/Ultratech.png";
// import Kajaria from "../../assets/PartnerLogos/Kajaria.png";
// import Jindal from "../../assets/PartnerLogos/Jindal.png";
// import Johnson from "../../assets/PartnerLogos/Johnson.png";
// import Dalmia from "../../assets/PartnerLogos/Dalmia.png";
// import Hindware from "../../assets/PartnerLogos/Hindware.png";
// import Nuvoco from "../../assets/PartnerLogos/Nuvoco.png";
// import Tata from "../../assets/PartnerLogos/TataTiscon.png";
// import Jk from "../../assets/PartnerLogos/jklakshmi.png";

// const logos = [
//   { src: Ultratech, alt: "Ultratech", brand: "ultratech" },
//   { src: Kajaria, alt: "Kajaria", brand: "kajaria" },
//   { src: Jindal, alt: "Jindal Steel & Power", brand: "jindal" },
//   { src: Johnson, alt: "Johnson", brand: "johnson" },
//   { src: Dalmia, alt: "Dalmia", brand: "dalmia" },
//   { src: Hindware, alt: "Hindware", brand: "hindware" },
//   { src: Nuvoco, alt: "Nuvoco", brand: "nuvoco" },
//   { src: Tata, alt: "Tata Tiscon", brand: "tata" },
//   { src: Jk, alt: "JK Lakshmi", brand: "jk" },
// ];

// const Partners = () => {
//   const navigate = useNavigate();

//   const handlePartnerClick = (brand) => {
//     navigate(`/products?brand=${brand}`);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <div className="overflow-hidden bg-white py-6">
//       <div className="max-w-screen-xl mx-auto">
//         <div className="whitespace-nowrap animate-slide-right hover:animate-none flex gap-4 justify-center">
//           {[...logos, ...logos].map((logo, index) => (
//             <img
//               key={index}
//               src={logo.src}
//               alt={logo.alt}
//               className="h-20 w-20 sm:h-36 sm:w-36 object-contain cursor-pointer hover:scale-110 transition-transform duration-300"
//               onClick={() => handlePartnerClick(logo.brand)}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Partners;
